// Query string from a plain object, dropping empty values.
//
// Deliberately not buildQueryParams: that helper only emits `status` and `channel` when
// `source === 'attribution'` and knows nothing about most keys, so every other filter passed
// through it is silently dropped.
const qs = (params = {}) =>
  Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');

export default qs;
